import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'

import Premium from './user/Premium'
import { ButtonLink } from './utils/Button.jsx'

const FrontPage = () => {
  return (
    <div className="lg:flex lg:space-x-6">
      <div className="lg:w-1/2 lg:mb-0 mb-6">
        <h1 className="text-4xl text-green-600 mb-2">Campground Full?</h1>

        <div className="my-6 prose-xl">
          <p className="font-medium text-gray-500">
            Tell us where you want to camp, select a date range, and receive a notification when a site becomes
            available.
          </p>

          <p>
            For example, submit a request to stay at Bahia Honda State Park in Florida for 5 consecutive nights anytime
            between January 1 and March 1. We will check the reservation website every few minutes and if a site becomes
            available you will receive an email.
          </p>
          <p>Finish the process by clicking the reserve link in the email and making the reservation. </p>
        </div>

        <ButtonLink color="darkGreen" to="new" className="text-2xl">
          Make a Request
          <FontAwesomeIcon
            icon={faAngleRight}
            className="ml-4"
          />
        </ButtonLink>
      </div>
      <div className="lg:w-1/2">
        <Premium />
      </div>
    </div>
  )
}
export default FrontPage
